<template>
  <!-- eslint-disable -->
  <div class="message-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'2000'"
          :disabled="node.human"></v-text-field>
      </div>
    </div>
    <va-tinymce-input
      ref="tinymce"
      class="mb-4 w-full"
      :current-content="node.content"
      :editor-height="120"
      live-chat-message-preset
      title="Message"
      :forced-root-block-attrs="{ class: 'live-chat-message' }"
      auto-resize
      @update="content => updateMessageContent(content)" />

    <div class="message-item__label">
      {{ $t("shortcodes.live_chat_auto.answer_preview") }}
    </div>
    <img class="w-full mb-4" :src="currentImage" />
    <v-text-field
      class="message-item__settings--cssclass panzoom-ignore w-full"
      v-model="node.cssClass"
      :label="'Class'"
      persistent-placeholder
      :placeholder="''"></v-text-field>
    <div class="animated-button">
      <div class="animated-button__title">
        {{ $t("shortcodes.live_chat.enable_pulsing_buttons") }}
      </div>

      <v-switch
        class="animated-button__switch"
        v-model="node.animatedButtons"
        inset
        color="primary"
        :hide-details="'auto'"
        :ripple="false">
      </v-switch>
    </div>
  </div>
</template>

<script>
  import questionPreviewZip from "@/assets/images/svg/default-question-zip.svg";
  import questionPreviewCurrentInsurer from "@/assets/images/svg/default-question-current-insurer.svg";
  import questionPreviewMultipleVehicles from "@/assets/images/svg/default-question-yes-no.svg";
  import questionPreviewAgeGroup from "@/assets/images/svg/default-question-age-group.svg";
  import questionPreviewHomeOwnership from "@/assets/images/svg/default-question-yes-no.svg";
  import questionPreviewDui from "@/assets/images/svg/default-question-yes-no.svg";
  import questionPreviewContinuouslyInsured from "@/assets/images/svg/default-question-continuously-insured.svg";
  import questionPreviewIncidents from "@/assets/images/svg/default-question-incidents.svg";
  import questionPreviewSr22Form from "@/assets/images/svg/default-question-yes-no.svg";
  import questionPreviewIsInsured from "@/assets/images/svg/default-question-yes-no.svg";

  export default {
    name: "LiveChatDefaultQuestion",
    components: {},
    props: {
      node: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        currentImage: "",
      };
    },
    computed: {},
    mounted() {
      const questionPreviewImages = {
        zip: questionPreviewZip,
        current_insurer: questionPreviewCurrentInsurer,
        multiple_vehicles: questionPreviewMultipleVehicles,
        age_group: questionPreviewAgeGroup,
        home_ownership: questionPreviewHomeOwnership,
        dui: questionPreviewDui,
        continuously_insured: questionPreviewContinuouslyInsured,
        incidents: questionPreviewIncidents,
        sr_22_form: questionPreviewSr22Form,
        is_insured: questionPreviewIsInsured,
      };

      this.currentImage = questionPreviewImages[this.node.defaultQuestionType] || null;
    },
    methods: {
      updateContent(content) {
        if (this.$refs.tinymce) {
          this.$refs.tinymce.updateContent(content);
        }
      },
      updateMessageContent(content) {
        // eslint-disable-next-line vue/no-mutating-props
        this.node.content = content;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
  .message-item {
    &__label {
      color: get-color("subtitle");
      @include text-caption-bold();
      width: 100%;
      text-align: left;
      margin-bottom: 6px;
    }
  }

  .animated-button {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    width: 100%;
    &__title {
      color: get-color("subtitle");
      @include text-body-2-bold();
      padding-left: 4px;
    }
    &__switch {
      &::v-deep {
        .v-input--selection-controls__input {
          margin-right: 0;
        }
      }
    }
  }
</style>
